var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":_vm.modalId,"hide-footer":"","no-close-on-backdrop":"","size":"lg"}},[_c('div',{staticClass:"eula-modal-card"},[_c('eula')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }